
    import I18n from 'i18nObj';
    
      import 'translations/format_range';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('format_range');
  